var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { useWindowWidth } from "../shared/useWindowWidth";
var StyledContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n  overflow-x: hidden;\n"], ["\n  width: 100%;\n  position: relative;\n  overflow-x: hidden;\n"])));
var StyledInner = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  transform: ", ";\n  display: ", ";\n  transition: 0.2s all;\n"], ["\n  width: ", ";\n  transform: ", ";\n  display: ", ";\n  transition: 0.2s all;\n"])), function (props) { return props.pageWidth * props.count + "px"; }, function (props) { return "translateX(-" + props.pageWidth * props.pageIndex + "px)"; }, function (props) { return (props.pageWidth === 0 ? "none" : "flex"); });
var getClientWidth = function (ref, cb) {
    if (ref.current && ref.current.clientWidth > 0) {
        cb(ref.current.clientWidth);
    }
    else {
        window.requestAnimationFrame(function () { return getClientWidth(ref, cb); });
    }
};
export var useCarousel = function (_a) {
    var numOfPages = _a.numOfPages;
    var _b = useState(0), pageIndex = _b[0], setPageIndex = _b[1];
    var goTo = function (index) { return setPageIndex(index); };
    var back = function () { return pageIndex > 0 && setPageIndex(pageIndex - 1); };
    var forward = function () {
        return pageIndex < numOfPages - 1 && setPageIndex(pageIndex + 1);
    };
    return { pageIndex: pageIndex, goTo: goTo, back: back, forward: forward };
};
export var Carousel = function (_a) {
    var pageIndex = _a.pageIndex, pages = _a.pages, rest = __rest(_a, ["pageIndex", "pages"]);
    var _b = useState(0), pageWidth = _b[0], setPageWidth = _b[1];
    var windowWidth = useWindowWidth();
    var container = useRef();
    useEffect(function () {
        getClientWidth(container, function (clientWidth) {
            setPageWidth(clientWidth);
        });
    }, [windowWidth]);
    return (React.createElement(StyledContainer, __assign({ ref: container }, rest),
        React.createElement(StyledInner, { count: pages.length, pageIndex: pageIndex, pageWidth: pageWidth }, pages.map(function (page, i) { return (React.createElement(CarouselPage, { pageWidth: pageWidth, shouldRender: pageIndex === i }, page)); }))));
};
var StyledPageContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: ", ";\n  visibility: ", ";\n"], ["\n  width: ", ";\n  visibility: ", ";\n"])), function (props) { return props.pageWidth + "px" || "100%"; }, function (props) { return (props.shouldRender ? "visible" : "hidden"); });
var StyledPageInner = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  display: ", ";\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"], ["\n  width: 100%;\n  display: ", ";\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])), function (props) { return (props.shouldRender ? "flex" : "none"); });
var CarouselPage = function (_a) {
    var pageWidth = _a.pageWidth, shouldRender = _a.shouldRender, children = _a.children;
    return (React.createElement(StyledPageContainer, { pageWidth: pageWidth, shouldRender: shouldRender },
        React.createElement(StyledPageInner, { shouldRender: shouldRender }, children)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
